import styled from 'styled-components'

export const ResultsWrapper = styled.div`
    flex: 1;
    padding: 24px 24px 48px 24px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    align-items: center;
    justify-content: center;
    background-color: red;
    position: relative;
    background: ${({ theme }) => theme.colors.primaryWhite};
`

export const ResultsSummaryCard = styled.div`
    justify-content: center;
    border-radius: 15px;
    max-width: 800px;
    min-width: 520px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    padding: 24px 39px;
    border-radius: 15px;
    max-height: 75px;
    border: 1.5px solid ${({ theme }) => theme.colors.secondary100Transparent};
    background: ${({ theme }) => theme.colors.primaryWhite};
`
